export const REVIEW_QUEUE_TABLE_HEADERS = [
  "Channel",
  "Type",
  "Recorded by",
  "Submitted",
  "Status",
] as const;

export const REVIEW_QUEUE_NON_SORTABLE_COLUMNS = ["Status"];
